import React, { ReactElement, useState } from 'react';

import { Link } from 'gatsby';
import { StaticImage } from 'gatsby-plugin-image';

import { ROUTES } from '../../const/routes.const';
import { useButtons } from '../../hooks/data/buttons.hook';
import { Button, BUTTON_TYPES } from '../Button';
import { Logo } from '../Logo';
import { NUM_ASSETS } from './LandingPage.const';
import { LandingPageProps } from './LandingPage.types';

export const LandingPage: React.FC<LandingPageProps> = ({
	handleOnClick,
}): ReactElement => {
	const [currentImage, setCurrentImage] = useState<number>(1);

	const { buttonClose } = useButtons();

	const handleOnClickCampaignImage = (): void => {
		if (currentImage < NUM_ASSETS) {
			setCurrentImage(currentImage + 1);
			return;
		}

		setCurrentImage(1);
	};

	return (
		<section className="c-landing-page u-bg-primary">
			<header className="c-landing-page__header">
				<Link
					to={ROUTES.HOME}
					onClick={handleOnClick}
					className="c-link c-link--none">
					<h1 className="c-logo--small">
						<span className="u-hide-visually">Raf Simons</span>
						<Logo />
					</h1>
				</Link>
			</header>
			<div
				className="c-landing-page__carousel"
				onClick={handleOnClickCampaignImage}>
				{currentImage === 1 && (
					<StaticImage
						loading="eager"
						placeholder="none"
						objectFit="contain"
						src="../../assets/landingPageImages/1.jpg"
						alt=""
						className="c-landing-page__image"
					/>
				)}
				{currentImage === 2 && (
					<StaticImage
						loading="eager"
						placeholder="none"
						objectFit="contain"
						src="../../assets/landingPageImages/2.jpg"
						alt=""
						className="c-landing-page__image"
					/>
				)}
				{currentImage === 3 && (
					<StaticImage
						loading="eager"
						placeholder="none"
						objectFit="contain"
						src="../../assets/landingPageImages/3.jpg"
						alt=""
						className="c-landing-page__image"
					/>
				)}
				{currentImage === 4 && (
					<StaticImage
						loading="eager"
						placeholder="none"
						objectFit="contain"
						src="../../assets/landingPageImages/4.jpg"
						alt=""
						className="c-landing-page__image"
					/>
				)}
			</div>
			<footer className="c-landing-page__footer">
				<Button
					label={buttonClose?.label}
					accessibilityLabel={buttonClose?.accessibilityLabel}
					type={BUTTON_TYPES.MEDIUM}
					onClickButton={handleOnClick}
					className="u-color-secondary c-button--contrast-hover"
				/>
			</footer>
		</section>
	);
};
